import React from 'react'
import CryptoNews from './CryptoNews'

const Blog = () => {
  return (
    <div>
      <CryptoNews/>
    </div>
  )
}

export default Blog